/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Filters meta reducer
 */

import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { payloadReducer } from '@zcode/reducers'
import {
  DONE_FETCHING_MATCHING_COUNT,
  DONE_FETCHING_PROPERTY_TYPE_COUNTS,
  RESET_FILTERS,
  SET_IS_ZOE_SEARCH,
  SET_ZOE_LOCATION,
  START_FETCHING_MATCHING_COUNT,
  START_FETCHING_PROPERTY_TYPE_COUNTS,
  UPDATE_FILTERS,
} from '../constants/index'

const metaReducer = combineReducers({
  dirty: handleActions(
    {
      [UPDATE_FILTERS]: () => false,
      [RESET_FILTERS]: () => true,
    },
    true // schema defaulted to null; not sure which is right
  ),
  matchingCountFetching: handleActions(
    {
      [DONE_FETCHING_MATCHING_COUNT]: () => false,
      [START_FETCHING_MATCHING_COUNT]: () => true,
    },
    false
  ),
  propertyTypeCountsFetching: handleActions(
    {
      [DONE_FETCHING_PROPERTY_TYPE_COUNTS]: () => false,
      [START_FETCHING_PROPERTY_TYPE_COUNTS]: () => true,
    },
    false
  ),
  isZoeSearch: handleActions(
    {
      [SET_IS_ZOE_SEARCH]: payloadReducer,
    },
    false
  ),
  zoeLocation: handleActions(
    {
      [SET_ZOE_LOCATION]: payloadReducer,
    },
    null
  ),
})

export default metaReducer
